var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.04 167.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#053f4c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.91,125.28v-26A157.41,157.41,0,0,0,38.44,82.32,77.14,77.14,0,0,0,51,63.36a50,50,0,0,0,4.61-21.12q0-8.61-3.89-13.43T40.39,24Q33.84,24,30,27.68t-3.8,10a22,22,0,0,0,.62,5.33q.62,2.46,1.43,5.33L2.87,53.92A51.34,51.34,0,0,1,.72,45.83,45.69,45.69,0,0,1,0,37.73Q0,20.51,10.56,10.25T40.8,0Q60.9,0,72,10.87T83,41.83A62.35,62.35,0,0,1,78.43,66a75.91,75.91,0,0,1-13,20.71,148,148,0,0,1-19.48,18.45v20.1Zm-1,42.64V140.65H47.36v27.27Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.b5793dbc6ccd351db844ea1324fdd86f.svg";
export { ForwardRef as ReactComponent };